export default __webpack_public_path__ + "static/media/13.167e9977.png";